import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon, MDBFormInline  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../api';
import ban from '../img/math.png'
import { MDBTable, MDBTableBody, MDBTableHead,MDBBadge} from 'mdbreact';

export default class Modalshowevaluation extends Component {
    constructor(props) {
        super(props);
                this.state = {
                modal: false,

                send_id :'1', //ผู้ลงทะเบียน
                send_type : '', //ประเภท
                name_present : '', //ผู้นำเสนอ
                name_presentcertificate:'',
                name_article : '', //ชื่อบทความ
                major_precent : 'คณิตศาสตร์', //สาขาที่นำเสนอ
                send_uploadeword1 : null,
                send_uploadepdf1 : null,
                send_uploadeword12 : null,
                send_uploadepdf12 : null,
                URLdrive:'',
                send_date1 : '', //  วันที่ส่ง
                send_status : '', //สถานะ ชำระเงิน
                stapat : '0',   //สถานะส่ง

                iduser:'',
                radio: "",
                articletype:[],

                id_sendarticle:'',
                id_expertex:'',
                evaluation:[],
                }

                this.handleChange1 = this.handleChange1.bind(this);
                this.handleChange2 = this.handleChange2.bind(this);
      


                this.handleChangetype = this.handleChangetype.bind(this);
                this.toggle = this.toggle.bind(this);
                this.handleChangemajor = this.handleChangemajor.bind(this);
                this.handleChangenamepresent = this.handleChangenamepresent.bind(this);
                this.handleChangesend_name = this.handleChangesend_name.bind(this);
                this.onClickradio = this.onClickradio.bind(this);
                this.gettype = this.gettype.bind(this);
                this.handleChangenamepresentcer = this.handleChangenamepresentcer.bind(this);
                this.handleChangeURLdrive = this.handleChangeURLdrive.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.props.selectatf();
 this.gettype();
 if (localStorage.getItem('register_typemamber') === '1' || localStorage.getItem('register_typemamber') === '2') {
  this.setState({ send_status: '2'})
 }
}


onClickradio = (nr) => () => {
  this.setState({
    radio: nr,
  });

};

 componentDidMount() {
     //  const { iduser } = this.props.iduser
    //   console.log(id_send);
       this.setState({ id_sendarticle:this.props.id_sendarticle})
       this.setState({ id_expertex:this.props.id_expertex})

      setTimeout(() => {
        //ภายใน
        api.get('registercon/selectcommentexforuser/'+this.props.id_sendarticle+'/'+this.props.id_expertex)
        .then(res => {
          console.log(res);
        //  this.setState({ bankname: res.data, loading: false })
          this.setState({ evaluation: res.data})
        }) 
      }, 0);
  }

  gettype() {
    setTimeout(() => {
           
      api.get('registercon/selecttpresentationtype')
       .then(res => {
         console.log(res);
       //  this.setState({ bankname: res.data, loading: false })
         this.setState({ articletype: res.data})
       }) 
     }, 0);
 }



  //ปากเปล่าโปสเตอร์
  handleChangetype(event) {    this.setState({send_type: event.target.value});  }
  //ปากเปล่าโปสเตอร์สาขา
  handleChangemajor(event) {    this.setState({major_precent: event.target.value});  }
  //ผู้นำเสนอ
  handleChangenamepresent(event) {    this.setState({name_present: event.target.value});  }
    //ผู้นำเสนอ
    handleChangenamepresentcer(event) {    this.setState({name_presentcertificate: event.target.value});  }
//ผู้นำเสนอ
  handleChangesend_name(event) {    this.setState({name_article: event.target.value});  }


  handleChange1(event) {    this.setState({send_uploadeword1: event.target.files[0]});  }
  handleChange2(event) {    this.setState({send_uploadepdf1: event.target.files[0]});  }
  handleChangeURLdrive(event) {    this.setState({URLdrive: event.target.value});  }
 // handleChange4(event) {    this.setState({send_uploadepdf12: event.target.files[0]});  }




    render() {
        
         


        return (
          
            <MDBContainer className='text-left'>
           <div className='text-center'>
            {/* <MDBBtn color="deep-purple" onClick={this.toggle} size='sm'><MDBIcon icon="plus-square" />  รายละเอียดข้อเสนอแนะ</MDBBtn> */}
            <a><MDBBadge pill  color="success" onClick={this.toggle}>รายละเอียดข้อเสนอแนะ</MDBBadge></a>
            </div> 

            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <MDBModalHeader toggle={this.toggle}>รายละเอียดข้อเสนอแนะ</MDBModalHeader>

      
   
              <MDBModalBody>
              <img src={ban} className="rounded mx-auto " alt="aligment" />
             
              <div>
                 <br/>
                <p>รายละเอียดข้อเสนอแนะ</p>
              <MDBTable bordered responsive small>
                        <MDBTableHead color="grey darken-1" textWhite>
                            <tr>
                            <th>ลำดับ</th>
                            <th>หัวข้อ</th>
                            {/* <th>สถานะ</th> */}
                            <th>คำแนะนำ</th>
                            
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                        {this.state.evaluation.map((evaluation,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{evaluation.evaluation_nema}</td>
                        {/* <td>{evaluation.score === '1'?<>เหมาะสม</>:<>ไม่เหมาะสม</>}</td> */}
                        <td>{evaluation.comment_score}</td>
                       
                        </tr>
                      )}
                           
                        </MDBTableBody>
                    </MDBTable>
           
                    




              </div>
              
              </MDBModalBody>
              <MDBModalFooter>
                 {/* <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn> */}
                 {/* <MDBBtn color="primary" type='submit' >บันทึก</MDBBtn> */}
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
               
              </MDBModalFooter>
         
            </MDBModal>
          </MDBContainer>
          
        )
    }
}
